module.exports = __webpack_public_path__ + "static/media/home-video.161c4dce.mp4";